<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Créanciers pour lesquels il faut envoyer les codes du portail client"
      subtitle="Recherche de créanciers"
      autocomplete_idHistory="creditors"
      autocomplete_field="creancier.nom_soc || creancier.nom || creancier.prenom"
      bdTable="creditors_send_login"
      :actions="actions"
      :fields="fields"
      :Api="Api"
    >
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'creditorView', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(nom_soc)="data">
        <b-link :to="{ name: 'creditorView', params: { id: data.item.ID } }">
          {{ completeName(data.item) }}
        </b-link>
      </template>
      <template v-slot:cell(email)="data">
        <b-link active target="_blank" :href="'mailto:' + data.item.email">
          {{ data.item.email.toLowerCase() }}
        </b-link>
      </template>
      <template v-slot:cell(action)="data">
        <b-button size="sm" @click="send_login(data.item.ID)"><i class="fad fa-paper-plane"></i></b-button>
      </template>
    </bd-table-list>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
import creditors from "@/services/creditors.js";
export default {
  name: "ManageCreditorsSendLogin",
  components: {
    BdTableList,
  },
  data() {
    return {
      Api: gestion.creditors_send_login,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Créanciers pour lesquels il faut envoyer les codes du portail client",
          active: true,
        },
      ],
     
      fields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-right",
          thStyle: { width: "100px" },
        },

        {
          key: "nom_soc",
          label: "Créancier",
          class: "text-truncate",
          sortable: true,
        },
        {
          key: "email",
          label: "Courriel",
          class: "text-truncate",
          sortable: true,
        },
        {
          key: "telephone",
          label: "Téléphone",
          sortable: true,
        },
        {
          key: "gsm",
          label: "GSM",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          sortable: false
        }
      ],
    };
  },
  methods: {
    send_login() {
      creditors.sendLogin(this.creditor.ID.value).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Email envoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
        } else if (response.data.error) {
          this.$bvToast.toast("L'email n'a pas pu être envoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>